import React, { Component } from "react";

// reactstrap components
import {
    Card,
    CardTitle,
    CardFooter,
    CardHeader,
    CardBody,
    Row,
    Col,
    Table,
    Input,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import axios from "axios";
import { api_link } from "siteConfig";

class SiteSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            target_site_id: this.props.site,
            target_job_id: this.props.job,
            searchBar_visible: true,
            siteSearch_visible: false,
            siteDetails_visible: false,
            jobDetails_visible: false,
            jobVisits_visible: false,
            jobAttachments_visible: false,
            quoteDetails_visible: false,
            hTabs: "ht_site_details",
            siteResults: [],
            filteredResults: [],
            selectedSite: {},
            setFilter: props.filter,
            setSite: props.site,
            siteJobs: [],
            siteCertificates: [],
            siteOutstandingQuotes: [],
            dataState: [],
            selectRow: [],
            selectedJob: [],
            selectedQuote: [],
            jobDetails: [],
            jobVisitDetails: [],
            jobAttachments: [],
            quoteDetails: [],
            jobSearchTerm: '',
            quoteSearchTerm: '',
            previewModal: false,
            previewFile: null,
            attachmentsViewMode: 'list', // 'list' or 'thumbnail'
            largePreviewModal: false,
            largePreviewAttachment: null,
            largePreviewContent: null,
            loadedThumbnails: {}, // Store loaded thumbnails by attachmentId
            downloadingAll: false, // Loading state for download all button
            thumbnailQueue: [], // Queue for ordered thumbnail loading
            activeLoads: 0, // Track how many thumbnails are currently loading
            maxConcurrentLoads: 2, // Maximum thumbnails to load simultaneously
        };
    }

    async componentDidMount() {
        // Add custom CSS for modal close button
        const style = document.createElement('style');
        style.textContent = `
            .modal-header .close {
                background: #dc3545 !important;
                border: 1px solid #dc3545 !important;
                border-radius: 8px !important;
                width: 36px !important;
                height: 36px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                font-size: 20px !important;
                font-weight: 700 !important;
                color: white !important;
                opacity: 1 !important;
                transition: all 0.2s ease !important;
                margin: 0 !important;
                box-shadow: 0 2px 4px rgba(220,53,69,0.2) !important;
                position: absolute !important;
                top: 15px !important;
                right: 20px !important;
            }
            .modal-header .close:hover {
                background: #c82333 !important;
                color: white !important;
                border-color: #bd2130 !important;
                transform: scale(1.08) !important;
                box-shadow: 0 4px 8px rgba(220,53,69,0.3) !important;
            }
            .modal-header .close:focus {
                box-shadow: 0 0 0 3px rgba(220,53,69,0.25) !important;
                outline: none !important;
            }
            .modal-header .close:active {
                transform: scale(0.95) !important;
            }
        `;
        document.head.appendChild(style);

        if (sessionStorage.getItem("target_job_id") !== '0') {

            this.setState({ selectedJob: sessionStorage.getItem("target_job_id") });
            let selectedJob = sessionStorage.getItem("target_job_id");

            // this.loadAllSites(sessionStorage.getItem("site_ids"));
            this.loadSite(sessionStorage.getItem("target_site_id"));
            this.loadSiteCertificates(sessionStorage.getItem("target_site_id"));
            this.loadSiteOutstandingQuotes(sessionStorage.getItem("target_site_id"));

            // alert(selectedJob);
            this.loadJob(selectedJob);
            // this.loadJobVisits(selectedJob);
            // this.loadJobAttachments(selectedJob);

            this.setState({ hTabs: "ht_job_details" });
            this.setState({ jobDetails_visible: true });
            this.setState({ jobVisits_visible: true });
            this.setState({ jobAttachments_visible: true });
            this.setState({ quoteDetails_visible: false });
            // this.setState({ selectedSite: sessionStorage.getItem("target_site_id") });
            this.setState({ siteSearch_visible: false });
            this.setState({ siteDetails_visible: true });

            sessionStorage.setItem("target_job_id", '0');
            sessionStorage.setItem("target_site_id", '0');

        } else {

            this.loadAllSites(sessionStorage.getItem("site_ids"));
            if (this.state.setSite !== 'none') {
            }

        }
    }

    componentWillUnmount() {
        // Clean up blob URLs to prevent memory leaks
        this.cleanupThumbnails();
        
        // Clean up intersection observer
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
    }

    setFilter = (filter) => {
        if (filter !== 'none') {
            switch (filter) {
                case 'outstanding':
                    this.filterOutstanding();
                    this.setState({ siteSearch_visible: true });
                    break;
                case 'onsite':
                    this.filterOnSite();
                    this.setState({ siteSearch_visible: true });
                    break;
                case 'docsrequired':
                    this.filterDocsRequired();
                    this.setState({ siteSearch_visible: true });
                    break;
                default:
                    break;
            }
        }
    }

    loadSite = (sites) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getSites'
        try {
            axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": sites
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
                this.setState({ selectedSite: resp.data[0] });
                return resp.data;
            });

        } catch (error) {
            // Handle any errors that occur during the API request
        }
        return 'done';
    }

    loadAllSites = (sites) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getSites'
        try {
            axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": sites
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
                this.setState({ siteResults: resp.data });
                this.setState({ filteredResults: resp.data });
                this.setState({ siteSearch_visible: true });
                return resp.data;
            });

        } catch (error) {
            // Handle any errors that occur during the API request
        }
        return 'done';
    }

    filterResults = (e) => {
        this.setState({ siteSearch_visible: true });
        this.setState({ siteDetails_visible: false });
        this.setState({ jobDetails_visible: false });
        this.setState({ jobVisits_visible: false });
        this.setState({ jobAttachments_visible: false });
        this.setState({ quoteDetails_visible: false });
        this.setState({ selectedSite: {} });

        let searchValue = e.target.value;

        let filteredResults;

        filteredResults = this.state.siteResults.filter((site) => {
            let address = site.site_address1 + ' ' + site.site_address2 + ' ' + site.site_address3 + ' ' + site.site_address4;
            let searchTerms = searchValue.toUpperCase().split(' ');
            let isMatch = false;

            for (let term of searchTerms) {
                if (site.site_ref.toUpperCase().includes(term)
                    || site.site_name.toUpperCase().includes(term)
                    || address.toUpperCase().includes(term)
                    || site.site_postcode.toUpperCase().includes(term)
                ) {
                    isMatch = true;
                } else {
                    isMatch = false;
                    break;
                }
            }

            if (isMatch) {
                return site;
            } else {
                return '';
            }
        });


        this.setState({ filteredResults });
        this.setState({ siteSearch_visible: true });
    }

    loadSiteJobsData = async (site) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getJobs';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": site
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadSiteJobs = async (siteId) => {
        const siteJobData = await this.loadSiteJobsData(siteId);
        this.setState({ siteJobs: siteJobData });
    }

    loadSiteCertificatesData = async (site) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getCerts';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": site
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadSiteCertificates = async (siteId) => {
        const siteCertificatesData = await this.loadSiteCertificatesData(siteId);
        this.setState({ siteCertificates: siteCertificatesData });
    }

    loadSiteOutstandingQuotesData = async (site) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getOutstandingQuotes';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": site
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadSiteOutstandingQuotes = async (siteId) => {
        const siteOutstandingQuotesData = await this.loadSiteOutstandingQuotesData(siteId);
        this.setState({ siteOutstandingQuotes: siteOutstandingQuotesData });
    }

    loadJobData = async (job) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getJob';
        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": job
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadJob = async (jobId) => {
        const jobData = await this.loadJobData(jobId);
        this.setState({ jobDetails: jobData });
    }

    loadJobVisitData = async (job) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getJobSessions';
        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": job
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadJobVisits = async (jobId) => {
        const jobVisitData = await this.loadJobVisitData(jobId);
        this.setState({ jobVisitDetails: jobVisitData });
    }

    loadJobAttachmentsData = async (job) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getJobAttachments';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": job
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            // console.log(response.data);
            return response.data || []; // Return empty array if response.data is null/undefined
        } catch (error) {
            // Handle any errors that occur during the API request
            console.error('Error loading job attachments:', error);
            return []; // Return empty array on error
        }
    }

    loadJobAttachments = async (jobId) => {
        // Clean up previous thumbnails before loading new ones
        this.cleanupThumbnails();
        const jobAttachmentsData = await this.loadJobAttachmentsData(jobId);
        // Ensure we always set an array, even if API returns null/undefined
        this.setState({ jobAttachments: Array.isArray(jobAttachmentsData) ? jobAttachmentsData : [] });
        
        // If we're already in thumbnail view, reinitialize lazy loading for the new attachments
        if (this.state.attachmentsViewMode === 'thumbnail') {
            console.log('Already in thumbnail view, reinitializing lazy loading for new job');
            setTimeout(() => this.loadAllThumbnails(), 200);
        }
    }

    loadQuoteData = async (quote) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getQuote';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": quote
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadQuote = async (quoteId) => {
        const quoteData = await this.loadQuoteData(quoteId);
        this.setState({ quoteDetails: quoteData });
    }

    downloadAttachment = async (job, attachmentid, attachmentType) => {

        let url = 'https://' + api_link + 'customer_portal_v2/getAttachment'

        axios({
            method: "post",
            url: url,
            data: {
                "referurl": url,
                "var1": job,
                "var2": attachmentid,
                "var3": attachmentType
            },
            headers: {
                "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                // "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }).then(resp => {

            const pdfData = atob(resp.data.content);
            const bytes = new Uint8Array(pdfData.length);
            for (let i = 0; i < pdfData.length; i++) {
                bytes[i] = pdfData.charCodeAt(i);
            }
            let file = new Blob([bytes], { type: resp.data.mime });

            //download file
            let fileURL = URL.createObjectURL(file);

            window.open(fileURL);

        }).catch(err => {
        });

    }

    loadThumbnail = async (job, attachmentid, attachmentType) => {
        console.log(`Loading thumbnail for Job: ${job}, ItemID: ${attachmentid}, Type: ${attachmentType}`);

        try {
            // Use the new getThumbnail endpoint for better performance
            let url = 'https://' + api_link + 'customer_portal_v2/getThumbnail';
            console.log('Calling thumbnail API:', url);

            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": job,
                    "var2": attachmentid,
                    "var3": attachmentType,
                    "var4": 150, // thumbnail width - reduced for faster loading
                    "var5": 150,  // thumbnail height - reduced for faster loading
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });

            console.log('Thumbnail API response:', response.data);

            if (response.data && !response.data.error) {
                let thumbnailData = {
                    loaded: true,
                    error: false,
                    mime: response.data.mime,
                    isImage: response.data.isImage,
                    ext: response.data.ext,
                    name: response.data.name
                };

                // If it's an image with content, create blob URL
                if (response.data.content && response.data.isImage) {
                    const fileData = atob(response.data.content);
                    const bytes = new Uint8Array(fileData.length);
                    for (let i = 0; i < fileData.length; i++) {
                        bytes[i] = fileData.charCodeAt(i);
                    }
                    const blob = new Blob([bytes], { type: response.data.mime });
                    const thumbnailUrl = URL.createObjectURL(blob);
                    
                    thumbnailData.url = thumbnailUrl;
                } else {
                    // For non-images, we'll show file type icons
                    thumbnailData.url = null;
                }

                return thumbnailData;
            } else {
                console.error('Thumbnail API returned error:', response.data?.error);
                return { error: true, loaded: false };
            }
        } catch (err) {
            console.error('Thumbnail loading error:', err);
            console.error('Error details:', err.response?.data || err.message);
            return { error: true, loaded: false };
        }
    }

    renderThumbnail = (attachment) => {
        const thumbnailKey = `${attachment.JobID}_${attachment.ItemID}`;
        const thumbnail = this.state.loadedThumbnails[thumbnailKey];

        // Show loading placeholder with progress bar
        if (!thumbnail || thumbnail.loading) {
            const progress = thumbnail?.progress || 0;
            return (
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                    minHeight: '150px',
                    position: 'relative'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        color: '#6c757d'
                    }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: '24px', marginBottom: '8px' }} />
                        <span style={{ fontSize: '12px', marginBottom: '8px' }}>Loading...</span>
                        
                        {/* Progress Bar */}
                        <div style={{
                            width: '80%',
                            height: '4px',
                            backgroundColor: '#e9ecef',
                            borderRadius: '2px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: `${progress}%`,
                                height: '100%',
                                backgroundColor: '#007bff',
                                transition: 'width 0.3s ease'
                            }}></div>
                        </div>
                        <span style={{ fontSize: '10px', marginTop: '4px' }}>{progress}%</span>
                    </div>
                </div>
            );
        }

        // If thumbnail is loaded and successful
        if (thumbnail && !thumbnail.loading && !thumbnail.error && thumbnail.url) {
            // Check if it's an image type
            if (thumbnail.mime && thumbnail.mime.startsWith('image/')) {
                return (
                    <img 
                        src={thumbnail.url}
                        alt={attachment.Attachment}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                );
            } else {
                // For non-image files, show file type icon as thumbnail
                const getFileIcon = (mime) => {
                    if (mime.includes('pdf')) return { icon: 'far fa-file-pdf', color: '#dc3545' };
                    if (mime.includes('word') || mime.includes('document')) return { icon: 'far fa-file-word', color: '#2b579a' };
                    if (mime.includes('excel') || mime.includes('sheet')) return { icon: 'far fa-file-excel', color: '#207245' };
                    if (mime.includes('powerpoint') || mime.includes('presentation')) return { icon: 'far fa-file-powerpoint', color: '#d24726' };
                    if (mime.includes('text')) return { icon: 'far fa-file-alt', color: '#6c757d' };
                    if (mime.includes('zip') || mime.includes('rar')) return { icon: 'far fa-file-archive', color: '#fd7e14' };
                    return { icon: 'far fa-file', color: '#6c757d' };
                };

                const fileType = getFileIcon(thumbnail.mime);
                return (
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <i className={fileType.icon} style={{
                            fontSize: '64px',
                            color: fileType.color
                        }}></i>
                    </div>
                );
            }
        }

        // If thumbnail failed to load
        if (thumbnail && thumbnail.error) {
            return (
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa'
                }}>
                    <i className="fa fa-exclamation-triangle" style={{
                        fontSize: '48px',
                        color: '#dc3545'
                    }}></i>
                </div>
            );
        }

        // Default loading state
        return (
            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa'
            }}>
                <i className="fa fa-spinner fa-spin" style={{
                    fontSize: '48px',
                    color: '#6c757d'
                }}></i>
            </div>
        );
    }

    // Initialize intersection observer for lazy loading
    initializeIntersectionObserver = () => {
        if (!this.intersectionObserver) {
            this.intersectionObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const jobId = entry.target.getAttribute('data-job-id');
                            const itemId = entry.target.getAttribute('data-item-id');
                            const attachmentType = entry.target.getAttribute('data-attachment-type');
                            const thumbnailKey = `${jobId}_${itemId}`;
                            
                            console.log(`Intersection observed for Job: ${jobId}, ItemID: ${itemId}, Type: ${attachmentType}`);
                            
                            // Only queue if not already loaded or loading
                            if (!this.state.loadedThumbnails[thumbnailKey]) {
                                this.queueThumbnailLoad(jobId, itemId, attachmentType);
                            }
                            
                            // Stop observing this element once queued
                            this.intersectionObserver.unobserve(entry.target);
                        }
                    });
                },
                {
                    root: null, // Use viewport as root
                    rootMargin: '20px', // Reduced from 50px to 20px for more controlled loading
                    threshold: 0.1 // Trigger when 10% of element is visible
                }
            );
        }
    }

    // Load thumbnails when switching to thumbnail view (lazy loading approach)
    loadAllThumbnails = async () => {
        console.log('Initializing lazy loading for thumbnails');
        
        // Clean up any existing observers first
        this.cleanupThumbnails();
        
        // For lazy loading, we don't load all at once
        // Instead, initialize the intersection observer
        this.initializeIntersectionObserver();
        console.log('Intersection observer initialized:', !!this.intersectionObserver);
        
        // Check if jobAttachments exists before proceeding
        if (!this.state.jobAttachments || this.state.jobAttachments.length === 0) {
            console.log('No job attachments to load');
            return;
        }
        
        console.log(`Setting up lazy loading for ${this.state.jobAttachments.length} thumbnails`);
        
        // After a short delay, observe all thumbnail containers for lazy loading
        setTimeout(() => {
            const thumbnailContainers = document.querySelectorAll('[data-job-id]');
            console.log(`Found ${thumbnailContainers.length} thumbnail containers to observe`);
            thumbnailContainers.forEach(container => {
                if (this.intersectionObserver) {
                    console.log('Observing container for:', container.getAttribute('data-job-id'), container.getAttribute('data-item-id'));
                    this.intersectionObserver.observe(container);
                }
            });
        }, 200);
    }

    togglePreviewModal = () => {
        // Clean up any existing object URLs
        if (this.state.previewFile && this.currentPreviewUrl) {
            URL.revokeObjectURL(this.currentPreviewUrl);
            this.currentPreviewUrl = null;
        }
        
        this.setState({
            previewModal: !this.state.previewModal,
            previewFile: null
        });
    }

    openFilePreview = (attachment) => {
        if (attachment.FileBlob) {
            this.setState({
                previewFile: attachment,
                previewModal: true
            });
        }
    }

    toggleAttachmentsView = () => {
        const newMode = this.state.attachmentsViewMode === 'list' ? 'thumbnail' : 'list';
        this.setState({
            attachmentsViewMode: newMode
        });
        
        // Initialize lazy loading when switching to thumbnail view
        if (newMode === 'thumbnail') {
            // Small delay to ensure DOM is updated
            setTimeout(() => {
                this.loadAllThumbnails();
            }, 100);
        }
    }

    // Clean up blob URLs and intersection observer to prevent memory leaks
    cleanupThumbnails = () => {
        // Clean up blob URLs
        Object.values(this.state.loadedThumbnails).forEach(thumbnail => {
            if (thumbnail.url) {
                URL.revokeObjectURL(thumbnail.url);
            }
        });
        
        // Clean up intersection observer
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
        
        // Reset thumbnail state and queue
        this.setState({ 
            loadedThumbnails: {},
            thumbnailQueue: [],
            activeLoads: 0
        });
    }

    // Process thumbnail loading queue with concurrency control
    processThumbnailQueue = () => {
        // Only process if we have queue items and haven't reached max concurrent loads
        while (this.state.thumbnailQueue.length > 0 && this.state.activeLoads < this.state.maxConcurrentLoads) {
            const item = this.state.thumbnailQueue.shift();
            this.setState(prevState => ({
                thumbnailQueue: prevState.thumbnailQueue.slice(1),
                activeLoads: prevState.activeLoads + 1,
                loadedThumbnails: {
                    ...prevState.loadedThumbnails,
                    [item.key]: { loading: true, progress: 0 }
                }
            }));
            
            // Start loading this thumbnail
            this.loadThumbnailFromQueue(item);
        }
    }

    // Load thumbnail from queue item
    loadThumbnailFromQueue = async (queueItem) => {
        const { jobId, itemId, fileType, key } = queueItem;
        
        try {
            // Update progress to show it's starting
            this.setState(prevState => ({
                loadedThumbnails: {
                    ...prevState.loadedThumbnails,
                    [key]: { loading: true, progress: 25 }
                }
            }));

            const thumbnail = await this.loadThumbnail(jobId, itemId, fileType);
            
            if (thumbnail && !thumbnail.error) {
                // Update progress to completion
                this.setState(prevState => ({
                    loadedThumbnails: {
                        ...prevState.loadedThumbnails,
                        [key]: { loading: true, progress: 75 }
                    }
                }));

                // Mark as completed with the thumbnail data
                this.setState(prevState => ({
                    loadedThumbnails: {
                        ...prevState.loadedThumbnails,
                        [key]: { ...thumbnail, loading: false, progress: 100 }
                    },
                    activeLoads: prevState.activeLoads - 1
                }));
            } else {
                // Handle failed thumbnail
                this.setState(prevState => ({
                    loadedThumbnails: {
                        ...prevState.loadedThumbnails,
                        [key]: { error: true, loading: false, progress: 100 }
                    },
                    activeLoads: prevState.activeLoads - 1
                }));
            }
        } catch (error) {
            console.error('Error loading thumbnail from queue:', error);
            this.setState(prevState => ({
                loadedThumbnails: {
                    ...prevState.loadedThumbnails,
                    [key]: { error: true, loading: false, progress: 100 }
                },
                activeLoads: prevState.activeLoads - 1
            }));
        }
        
        // Process next item in queue
        setTimeout(() => this.processThumbnailQueue(), 100);
    }

    // Add thumbnail to loading queue in order
    queueThumbnailLoad = (jobId, itemId, fileType) => {
        const key = `${jobId}_${itemId}`;
        
        // Check if already loaded or in queue
        if (this.state.loadedThumbnails[key] || 
            this.state.thumbnailQueue.some(item => item.key === key)) {
            return;
        }
        
        // Add to queue
        this.setState(prevState => ({
            thumbnailQueue: [...prevState.thumbnailQueue, { jobId, itemId, fileType, key }]
        }), () => {
            // Process queue after state update
            this.processThumbnailQueue();
        });
    }

    // Open larger preview modal
    openPreviewModal = async (attachment) => {
        console.log('Opening preview for:', attachment.Attachment);
        
        try {
            // Get the full file content using the existing getAttachment endpoint
            let url = 'https://' + api_link + 'customer_portal_v2/getAttachment';

            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": attachment.JobID,
                    "var2": attachment.ItemID,
                    "var3": attachment.FileType
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });

            if (response.data && !response.data.error) {
                console.log('Preview API response:', response.data);
                this.setState({
                    largePreviewModal: true,
                    largePreviewAttachment: attachment,
                    largePreviewContent: response.data
                });
            } else {
                console.error('Failed to load preview:', response.data?.error);
            }
        } catch (err) {
            console.error('Preview loading error:', err);
        }
    }

    // Close larger preview modal
    closePreviewModal = () => {
        // Clean up any blob URLs that might be in use
        if (this.state.largePreviewContent) {
            // Find and revoke any blob URLs in the DOM
            const iframes = document.querySelectorAll('iframe');
            const images = document.querySelectorAll('img');
            [...iframes, ...images].forEach(element => {
                if (element.src && element.src.startsWith('blob:')) {
                    URL.revokeObjectURL(element.src);
                }
            });
        }

        this.setState({
            largePreviewModal: false,
            largePreviewAttachment: null,
            largePreviewContent: null
        });
    }

    // Download all attachments as ZIP
    downloadAllAttachments = async () => {
        if (!this.state.jobAttachments || this.state.jobAttachments.length === 0) {
            alert('No attachments to download');
            return;
        }

        // selectedJob is stored as a JobID value, not an object
        let jobId = this.state.selectedJob;
        
        // Fallback: get JobID from first attachment if selectedJob is not available
        if (!jobId && this.state.jobAttachments && this.state.jobAttachments.length > 0) {
            jobId = this.state.jobAttachments[0].JobID;
        }
        
        if (!jobId) {
            alert('No job selected. Please select a job first.');
            return;
        }

        try {
            // Set loading state
            this.setState({ downloadingAll: true });

            let url = 'https://' + api_link + 'customer_portal_v2/downloadAllAttachments';

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'api-key': 'ad8acb-e20326-93d0b2-11e5f2-d78c2e',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    jobId: jobId
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Check if response is JSON (error) or file (success)
            const contentType = response.headers.get('content-type');
            
            if (contentType && contentType.includes('application/json')) {
                // It's an error response
                const errorData = await response.json();
                throw new Error(errorData.error || 'Unknown error occurred');
            }

            // It's a file download
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            
            // Get filename from Content-Disposition header or use default
            const disposition = response.headers.get('Content-Disposition');
            let filename = `Job_${jobId}_Attachments.zip`;
            
            if (disposition && disposition.includes('filename=')) {
                const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            // Create download link and trigger download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up blob URL
            setTimeout(() => {
                window.URL.revokeObjectURL(downloadUrl);
            }, 1000);

        } catch (error) {
            alert(`Failed to download attachments: ${error.message}`);
        } finally {
            // Reset loading state
            setTimeout(() => {
                this.setState({ downloadingAll: false });
            }, 3000); // Show "Please Wait..." for 3 seconds minimum
        }
    }

    // Render large preview content
    renderLargePreview = () => {
        const { largePreviewContent, largePreviewAttachment } = this.state;
        
        if (!largePreviewContent || !largePreviewAttachment) {
            return <div>Loading preview...</div>;
        }

        try {
            console.log('Rendering preview for content:', {
                hasContent: !!largePreviewContent.content,
                mime: largePreviewContent.mime,
                size: largePreviewContent.size,
                contentLength: largePreviewContent.content ? largePreviewContent.content.length : 0
            });

            // Check if we have content
            if (!largePreviewContent.content) {
                throw new Error('No content data received from API');
            }

            // Convert base64 to blob URL for preview
            const byteCharacters = atob(largePreviewContent.content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: largePreviewContent.mime });
            const blobUrl = URL.createObjectURL(blob);

            // Determine how to render based on file type
            if (largePreviewContent.mime.startsWith('image/')) {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <img 
                            src={blobUrl}
                            alt={largePreviewAttachment.Attachment}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '70vh',
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                            onLoad={() => {
                                // Clean up blob URL after image loads
                                setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                            }}
                        />

                    </div>
                );
            } else if (largePreviewContent.mime === 'application/pdf') {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <iframe
                            src={`${blobUrl}#view=FitV&zoom=page-fit`}
                            style={{
                                width: '100%',
                                height: '70vh',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                            title={largePreviewAttachment.Attachment}
                        />

                    </div>
                );
            } else {
                return (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="far fa-file" style={{ fontSize: '64px', color: '#ccc', marginBottom: '20px' }}></i>
                        <h4>Preview not available</h4>
                        <p>This file type cannot be previewed in the browser.</p>
                        <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
                            <strong>File:</strong> {largePreviewAttachment.Attachment}<br/>
                            <strong>Size:</strong> {largePreviewContent.size ? (largePreviewContent.size / 1024 / 1024).toFixed(2) + ' MB' : 'Unknown'}<br/>
                            <strong>Type:</strong> {largePreviewContent.mime}
                        </div>
                        <div style={{ marginTop: '20px' }}>
                            <button 
                                className="btn btn-primary"
                                onClick={() => this.downloadAttachment(largePreviewAttachment.JobID, largePreviewAttachment.ItemID, largePreviewAttachment.FileType)}
                            >
                                <i className="fa fa-download"></i> Download File
                            </button>
                        </div>
                    </div>
                );
            }
        } catch (error) {
            console.error('Error rendering preview:', error);
            return (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <i className="fa fa-exclamation-triangle" style={{ fontSize: '48px', color: '#dc3545', marginBottom: '20px' }}></i>
                    <h4>Error Loading Preview</h4>
                    <p>There was an error loading the file preview.</p>
                </div>
            );
        }
    }

    renderFilePreview = (fileBlob, fileName, fileType) => {
        if (!fileBlob) return null;

        try {
            // Convert base64 to blob URL for preview
            const byteCharacters = atob(fileBlob);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            
            // Determine file type and MIME type for preview
            const extension = fileName ? fileName.split('.').pop().toLowerCase() : '';
            const mimeType = fileType || '';
            
            // Determine the correct MIME type for the blob
            let blobMimeType = mimeType;
            if (!blobMimeType) {
                switch (extension) {
                    case 'pdf':
                        blobMimeType = 'application/pdf';
                        break;
                    case 'jpg':
                    case 'jpeg':
                        blobMimeType = 'image/jpeg';
                        break;
                    case 'png':
                        blobMimeType = 'image/png';
                        break;
                    case 'gif':
                        blobMimeType = 'image/gif';
                        break;
                    case 'bmp':
                        blobMimeType = 'image/bmp';
                        break;
                    case 'webp':
                        blobMimeType = 'image/webp';
                        break;
                    case 'txt':
                        blobMimeType = 'text/plain';
                        break;
                    case 'csv':
                        blobMimeType = 'text/csv';
                        break;
                    default:
                        blobMimeType = 'application/octet-stream';
                }
            }
            
            const blob = new Blob([byteArray], { type: blobMimeType });
            const url = URL.createObjectURL(blob);

            if (mimeType.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <img 
                            src={url} 
                            alt={fileName}
                            style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }}
                            onLoad={() => {
                                // Clean up object URL after image loads
                                setTimeout(() => URL.revokeObjectURL(url), 5000);
                            }}
                        />
                    </div>
                );
            } else if (mimeType.includes('pdf') || extension === 'pdf') {
                // Create a data URL instead of blob URL for better PDF compatibility
                const dataUrl = `data:application/pdf;base64,${fileBlob}`;
                
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <strong>PDF Preview:</strong> {fileName}
                        </div>
                        <div style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
                            <iframe
                                src={dataUrl}
                                title={fileName}
                                style={{ width: '100%', height: '500px', border: 'none' }}
                                type="application/pdf"
                            />
                        </div>
                        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                            <p>If the PDF doesn't display properly, you can:</p>
                            <a href={dataUrl} download={fileName} style={{ textDecoration: 'none', marginRight: '10px' }}>
                                <Button color="primary" size="sm">Download PDF</Button>
                            </a>
                            <a href={dataUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                <Button color="secondary" size="sm">Open in New Tab</Button>
                            </a>
                        </div>
                    </div>
                );
            } else if (mimeType.includes('text') || ['txt', 'csv'].includes(extension)) {
                // For text files, try to display the content
                const textContent = byteCharacters; // Already decoded from base64
                return (
                    <div style={{ padding: '10px', backgroundColor: '#f5f5f5', whiteSpace: 'pre-wrap', maxHeight: '400px', overflow: 'auto' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <strong>File content:</strong> {fileName}
                        </div>
                        <div style={{ fontFamily: 'monospace', fontSize: '12px' }}>
                            {textContent.length > 5000 ? textContent.substring(0, 5000) + '...\n\n[Content truncated - download for full content]' : textContent}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <a href={url} download={fileName}>Download full file</a>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>Preview not available for this file type: {extension || 'unknown'}</p>
                        <p>MIME Type: {mimeType || 'unknown'}</p>
                        <a href={url} download={fileName} style={{ textDecoration: 'none' }}>
                            <Button color="primary" size="sm">Download file</Button>
                        </a>
                    </div>
                );
            }
        } catch (error) {
            console.error('Error creating file preview:', error);
            return (
                <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
                    <p>Error loading file preview</p>
                    <p>The file may be corrupted or in an unsupported format.</p>
                </div>
            );
        }
    }

    sethTabs = (hTabs) => {
        this.setState({ hTabs });
        switch (hTabs) {
            case "ht_site_details":
                // Code for handling "ht_site_details" tab
                break;
            case "ht_jobs":
                this.setState({ jobDetails_visible: false });
                this.setState({ jobVisits_visible: false });
                this.setState({ jobAttachments_visible: false });
                this.setState({ quoteDetails_visible: false });
                this.loadSiteJobs(this.state.selectedSite.site_id);
                break;
            case "ht_site_certification":
                this.setState({ jobDetails_visible: false });
                this.setState({ jobVisits_visible: false });
                this.setState({ jobAttachments_visible: false });
                this.setState({ quoteDetails_visible: false });
                this.loadSiteCertificates(this.state.selectedSite.site_id);
                break;
            case "ht_outstanding_quotes":
                this.setState({ jobDetails_visible: false });
                this.setState({ jobVisits_visible: false });
                this.setState({ jobAttachments_visible: false });
                this.setState({ quoteDetails_visible: false });
                this.loadSiteOutstandingQuotes(this.state.selectedSite.site_id);
                break;
            case "ht_job_details":
                // this.setState({ jobDetails: [] });
                this.loadJob(this.state.selectedJob);
                break;
            case "ht_job_visits":
                // this.setState({ jobVisitDetails: [] });
                this.loadJobVisits(this.state.selectedJob);
                break;
            case "ht_job_attachments":
                // this.setState({ jobAttachments: [] });
                this.loadJobAttachments(this.state.selectedJob);
                break;
            case "ht_quote_details":
                // this.setState({ quoteDetails: [] });
                // this.loadQuote('76461');
                break;
            default:
                break;
        }
    };

    handleJobRowClick = (JobID) => {
        // Clean up thumbnails from previous job
        this.cleanupThumbnails();
        
        // Reset jobAttachments to empty array to prevent render errors
        this.setState({ jobAttachments: [] });
        
        // Reset view mode to list when switching jobs
        this.setState({ attachmentsViewMode: 'list' });
        
        this.loadJob(JobID);
        this.setState({ hTabs: "ht_job_details" });
        this.setState({ selectedJob: JobID });
        this.setState({ jobDetails_visible: true });
        this.setState({ jobVisits_visible: true });
        this.setState({ jobAttachments_visible: true });
        this.setState({ quoteDetails_visible: false });
        
        // Scroll to the top of job details navigation for better UX
        setTimeout(() => {
            // Find the content div which uses Perfect Scrollbar
            const contentDiv = document.querySelector('.content');
            const mainPanel = document.querySelector('.main-panel');
            
            if (mainPanel && mainPanel.scrollTop !== undefined) {
                // If main-panel has scrollTop property, use it
                mainPanel.scrollTop = 0;
            } else if (contentDiv) {
                // Try to find Perfect Scrollbar instance
                if (contentDiv.scrollTop !== undefined) {
                    contentDiv.scrollTop = 0;
                }
                
                // Also try to reset Perfect Scrollbar if it exists
                const psRail = document.querySelector('.ps__rail-y .ps__thumb-y');
                if (psRail) {
                    psRail.style.top = '0px';
                }
                
                // If Perfect Scrollbar library is available globally
                if (window.PerfectScrollbar || window.Ps) {
                    const ps = window.PerfectScrollbar || window.Ps;
                    if (ps.update) {
                        ps.update(mainPanel || contentDiv);
                    }
                }
            } else {
                // Fallback: scroll the window
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }, 100); // Small delay to ensure DOM updates
    }

    handleQuoteRowClick = (quoteId) => {
        this.loadQuote(quoteId);
        this.setState({ hTabs: "ht_quote_details" });
        this.setState({ selectedQuote: quoteId });
        this.setState({ jobDetails_visible: false });
        this.setState({ jobVisits_visible: false });
        this.setState({ jobAttachments_visible: false });
        this.setState({ quoteDetails_visible: true });
        
        // Scroll to the top of quote details for better UX
        setTimeout(() => {
            // Find the content div which uses Perfect Scrollbar
            const contentDiv = document.querySelector('.content');
            const mainPanel = document.querySelector('.main-panel');
            
            if (mainPanel && mainPanel.scrollTop !== undefined) {
                // If main-panel has scrollTop property, use it
                mainPanel.scrollTop = 0;
            } else if (contentDiv) {
                // Try to find Perfect Scrollbar instance
                if (contentDiv.scrollTop !== undefined) {
                    contentDiv.scrollTop = 0;
                }
                
                // Also try to reset Perfect Scrollbar if it exists
                const psRail = document.querySelector('.ps__rail-y .ps__thumb-y');
                if (psRail) {
                    psRail.style.top = '0px';
                }
                
                // If Perfect Scrollbar library is available globally
                if (window.PerfectScrollbar || window.Ps) {
                    const ps = window.PerfectScrollbar || window.Ps;
                    if (ps.update) {
                        ps.update(mainPanel || contentDiv);
                    }
                }
            } else {
                // Fallback: scroll the window
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }, 100); // Small delay to ensure DOM updates
    }

    render() {
        return (
            <>
                <PanelHeader
                    size="lg"
                    content={image}
                />
                <div className="content" style={{ marginTop: '-270px' }}>
                    {alert}


                    {/*START - Search Bar*/}
                    <Row style={this.state.searchBar_visible ? { display: '' } : { display: 'none' }}>
                        <Col xs={12} md={12}>
                            <Card className="card-chart">
                                <CardHeader>
                                    <CardTitle tag="h4">Site Search</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <InputGroup className="no-border">
                                            <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.filterResults(e)} />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText>
                                                    <i className="now-ui-icons ui-1_zoom-bold" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </form>
                                    <br />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {/*END - Search Bar*/}


                    {/* START - Search Results*/}
                    <Row style={this.state.siteSearch_visible ? { display: '' } : { display: 'none' }}>
                        <Col xs={12} md={12}>
                            <Card className="card-chart">
                                <CardHeader>
                                    <CardTitle tag="h4">{this.state.filteredResults.length} Results found</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Table>
                                        <thead className="jcwMainColour">
                                            <tr>
                                                <td>Site</td>
                                                <td>Name</td>
                                                <td>Address</td>
                                                <td>Postcode</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                // alert(this.state.filteredResults),
                                                this.state.filteredResults.map((site) => {
                                                    return (
                                                        <tr key={site.site_id} onClick={() => {
                                                            this.setState({ siteSearch_visible: false });
                                                            this.setState({ siteDetails_visible: true });
                                                            this.setState({ selectedSite: site });
                                                            this.setState({ hTabs: "ht_site_details" });
                                                            this.setState({ siteJobs: [] });
                                                            
                                                            // Scroll to the top of site details for better UX
                                                            setTimeout(() => {
                                                                // Find the content div which uses Perfect Scrollbar
                                                                const contentDiv = document.querySelector('.content');
                                                                const mainPanel = document.querySelector('.main-panel');
                                                                
                                                                if (mainPanel && mainPanel.scrollTop !== undefined) {
                                                                    // If main-panel has scrollTop property, use it
                                                                    mainPanel.scrollTop = 0;
                                                                } else if (contentDiv) {
                                                                    // Try to find Perfect Scrollbar instance
                                                                    if (contentDiv.scrollTop !== undefined) {
                                                                        contentDiv.scrollTop = 0;
                                                                    }
                                                                    
                                                                    // Also try to reset Perfect Scrollbar if it exists
                                                                    const psRail = document.querySelector('.ps__rail-y .ps__thumb-y');
                                                                    if (psRail) {
                                                                        psRail.style.top = '0px';
                                                                    }
                                                                    
                                                                    // If Perfect Scrollbar library is available globally
                                                                    if (window.PerfectScrollbar || window.Ps) {
                                                                        const ps = window.PerfectScrollbar || window.Ps;
                                                                        if (ps.update) {
                                                                            ps.update(mainPanel || contentDiv);
                                                                        }
                                                                    }
                                                                } else {
                                                                    // Fallback: scroll the window
                                                                    window.scrollTo({
                                                                        top: 0,
                                                                        behavior: 'smooth'
                                                                    });
                                                                }
                                                            }, 100); // Small delay to ensure DOM updates
                                                        }}>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{site.site_ref}</td>
                                                            <td>{site.site_name}</td>
                                                            <td>{[site.site_address1, site.site_address2, site.site_address3, site.site_address4].filter(Boolean).join(', ')}</td>
                                                            <td>{site.site_postcode}</td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </CardBody>
                                <CardFooter>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                    {/*END - Search Results*/}


                    {/*START - Tab Content*/}
                    <Row style={this.state.siteDetails_visible ? { display: '' } : { display: 'none' }}>
                        <Col xs={12} md={12}>
                            <Card className="card-chart">
                                <CardHeader>
                                    <CardTitle tag="h4">{this.state.selectedSite.site_name}</CardTitle>
                                </CardHeader>
                                <CardBody>


                                    {/*START - Tab Navigation*/}
                                    <center>
                                        <Nav pills className="nav-pills-primary" id="job-details-navigation">
                                            <NavItem>
                                                <NavLink className={this.state.hTabs === "ht_site_details" ? "active" : ""} onClick={() => this.sethTabs("ht_site_details")} >
                                                    Site Details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={this.state.hTabs === "ht_jobs" ? "active" : ""} onClick={() => this.sethTabs("ht_jobs")}>
                                                    Jobs
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={this.state.hTabs === "ht_site_certification" ? "active" : ""} onClick={() => this.sethTabs("ht_site_certification")}>
                                                    Site Certification
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={this.state.hTabs === "ht_outstanding_quotes" ? "active" : ""} onClick={() => this.sethTabs("ht_outstanding_quotes")}>
                                                    Outstanding Quotes
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={this.state.jobDetails_visible ? { display: '' } : { display: 'none' }}>
                                                <NavLink className={this.state.hTabs === "ht_job_details" ? "active" : ""} onClick={() => this.sethTabs("ht_job_details")}>
                                                    Job Details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={this.state.jobVisits_visible ? { display: '' } : { display: 'none' }}>
                                                <NavLink className={this.state.hTabs === "ht_job_visits" ? "active" : ""} onClick={() => this.sethTabs("ht_job_visits")}>
                                                    Job Visits
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={this.state.jobAttachments_visible ? { display: '' } : { display: 'none' }}>
                                                <NavLink className={this.state.hTabs === "ht_job_attachments" ? "active" : ""} onClick={() => this.sethTabs("ht_job_attachments")}>
                                                    Job Attachments
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={this.state.quoteDetails_visible ? { display: '' } : { display: 'none' }}>
                                                <NavLink className={this.state.hTabs === "ht_quote_details" ? "active" : ""} onClick={() => this.sethTabs("ht_quote_details")}>
                                                    Quote Details
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </center>
                                    {/*END - Tab Navigation*/}


                                    {/*START - Tab Content*/}
                                    <TabContent activeTab={this.state.hTabs} className="tab-space">


                                        {/*START - Tab Content - Site Details*/}
                                        <TabPane tabId="ht_site_details">
                                            <Table>
                                                <tbody>
                                                    <tr>
                                                        <td>JCW Site Reference</td>
                                                        <td>{this.state.selectedSite.site_ref}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>{this.state.selectedSite.site_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address Line 1</td>
                                                        <td>{this.state.selectedSite.site_address1}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address Line 2</td>
                                                        <td>{this.state.selectedSite.site_address2}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address Line 3</td>
                                                        <td>{this.state.selectedSite.site_address3}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address Line 4</td>
                                                        <td>{this.state.selectedSite.site_address4}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Postcode</td>
                                                        <td>{this.state.selectedSite.site_postcode}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Telephone</td>
                                                        <td>{this.state.selectedSite.site_phone}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </TabPane>
                                        {/*END - Tab Content - Site Details*/}


                                        {/*START - Tab Content - Jobs*/}
                                        <TabPane tabId="ht_jobs">
                                            {this.state.siteJobs.length > 0 ? (
                                                <>
                                                    <InputGroup className="no-border">
                                                        <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.setState({ jobSearchTerm: e.target.value })} />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText>
                                                                <i className="now-ui-icons ui-1_zoom-bold" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                    <Table>
                                                        <tbody>
                                                            <tr>
                                                                <td>Job Number</td>
                                                                <td>Order Number</td>
                                                                <td>Authority</td>
                                                                <td>Description</td>
                                                                <td>Status</td>
                                                                <td>Logged Date</td>
                                                                <td>Last Visit</td>
                                                                <td>Completed</td>
                                                            </tr>
                                                            {this.state.siteJobs.filter((job) =>
                                                                ((job.Name && job.Name.toLowerCase().includes(this.state.jobSearchTerm.toLowerCase()))
                                                                || (job.ToDo && job.ToDo.toLowerCase().includes(this.state.jobSearchTerm.toLowerCase()))
                                                                || (job.JobID && job.JobID.toString().includes(this.state.jobSearchTerm))
                                                                || (job.Reference && job.Reference.toLowerCase().includes(this.state.jobSearchTerm.toLowerCase()))
                                                                || (job.Authority && job.Authority.toLowerCase().includes(this.state.jobSearchTerm.toLowerCase())))
                                                            )
                                                            .map((job) => (
                                                                <tr onClick={() => this.handleJobRowClick(job.JobID)} key={job.JobID}>
                                                                    <td>{job.JobID}</td>
                                                                    <td>{job.Reference}</td>
                                                                    <td>{job.Authority}</td>
                                                                    <td>{job.ToDo ? job.ToDo.substr(0, 50) : ""}</td>
                                                                    <td>{job.Status}</td>
                                                                    <td>{job.Logged ? new Date(job.Logged).toLocaleDateString("en-GB") : ""}</td>
                                                                    <td>{job.LastVisit ? new Date(job.LastVisit).toLocaleDateString("en-GB") : ""}</td>
                                                                    <td>{job.Completed ? new Date(job.Completed).toLocaleDateString("en-GB") : ""}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </>
                                            ) : (
                                                <p>No results</p>
                                            )}
                                        </TabPane>
                                        {/*END - Tab Content - Jobs*/}


                                        {/*START - Tab Content - Site Certification*/}
                                        <TabPane tabId="ht_site_certification">
                                            {this.state.siteCertificates.length > 0 ? (
                                                <Table>
                                                    <tbody>
                                                        <tr>
                                                            <td>Type</td>
                                                            <td>Date</td>
                                                            <td>Action</td>
                                                        </tr>
                                                        {this.state.siteCertificates.map((job) => (
                                                            <tr key={job.jobid}>
                                                                <td>{job.Name} {job.JobID ? <sup style={{ marginLeft: 4, fontSize: 'smaller' }}>{job.JobID}</sup> : null}</td>
                                                                <td>{new Date(job.Date).toLocaleDateString("en-GB")}</td>
                                                                <td><Button onClick={() => this.downloadAttachment(job.JobID, job.ID, 'Certificate')} className="btn btn-round" color="primary" size="sm">Download</Button></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <p>No results</p>
                                            )}
                                        </TabPane>
                                        {/*END - Tab Content - Site Certification*/}


                                        {/*START - Tab Content - Outstanding Quotes*/}
                                        <TabPane tabId="ht_outstanding_quotes">
                                            {this.state.siteOutstandingQuotes.length > 0 ? (
                                                <>
                                                    <InputGroup className="no-border">
                                                        <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.setState({ quoteSearchTerm: e.target.value })} />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText>
                                                                <i className="now-ui-icons ui-1_zoom-bold" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                    <Table>
                                                        <tbody>
                                                            <tr>
                                                                <td>Quote Ref</td>
                                                                <td>Date Logged</td>
                                                                <td>Site ID</td>
                                                                <td>Site Name</td>
                                                                <td>Description</td>
                                                                <td>Priority</td>
                                                                <td>Total Price</td>
                                                            </tr>
                                                            {this.state.siteOutstandingQuotes.filter((quote) =>
                                                                ((quote.quote_ref && quote.quote_ref.toLowerCase().includes(this.state.quoteSearchTerm.toLowerCase()))
                                                                || (quote.site_alpha && quote.site_alpha.toLowerCase().includes(this.state.quoteSearchTerm.toLowerCase()))
                                                                || (quote.site_name && quote.site_name.toLowerCase().includes(this.state.quoteSearchTerm.toLowerCase()))
                                                                || (quote.description && quote.description.toLowerCase().includes(this.state.quoteSearchTerm.toLowerCase()))
                                                            ))
                                                            .map((quote, index) => (
                                                                <tr onClick={() => this.handleQuoteRowClick(quote.id)} key={index}>
                                                                    <td>{quote.quote_ref}</td>
                                                                    <td>{quote.submitted_to_customer ? new Date(quote.submitted_to_customer).toLocaleDateString("en-GB") : ""}</td>
                                                                    <td>{quote.site_alpha}</td>
                                                                    <td>{quote.site_name}</td>
                                                                    <td>{quote.description ? quote.description.substr(0, 50) : ""}</td>
                                                                    <td>{quote.priority}</td>
                                                                    <td>£{quote.total_value}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </>
                                            ) : (
                                                <p>No results</p>
                                            )}
                                            {/* <OutstandingQuotesTable
                                                selectedSiteId={this.state.selectedSite.site_id}
                                                data={this.state.dataState}
                                            /> */}
                                        </TabPane>
                                        {/*END - Tab Content - Outstanding Quotes*/}


                                        {/*START - Tab Content - Job Details*/}
                                        <TabPane tabId="ht_job_details">
                                            <Table>
                                                {this.state.jobDetails.map((job, index) => (
                                                    <tbody key={index}>
                                                        <tr>
                                                            <td style={{ width: '300px' }}>Job ID</td>
                                                            <td>{job.JobID}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Order Number</td>
                                                            <td>{job.Reference}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Authority</td>
                                                            <td>{job.Authority}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Logged Date</td>
                                                            <td>{new Date(job.Logged).toLocaleDateString("en-GB")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Status</td>
                                                            <td>{job.Status}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Completed Date</td>
                                                            <td>{job.Completed ? new Date(job.Completed).toLocaleDateString("en-GB") : ''}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Job Type</td>
                                                            <td>{job.JobType}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ verticalAlign: 'top' }}>Description</td>
                                                            <td style={{ backgroundColor: '#f5f5f5' }}>
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: (job.ToDo || '')
                                                                            .replace(/\\r\\n/g, '\n')
                                                                            .replace(/\r\n/g, '\n')
                                                                            .replace(/\r/g, '\n')
                                                                            .replace(/\n/g, '<br />')
                                                                            .replace(/^(<br \/>)+/i, '') // remove leading <br />
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </Table>
                                        </TabPane>
                                        {/*END - Tab Content - Job Details*/}


                                        {/*START - Tab Content - Job Visits*/}
                                        <TabPane tabId="ht_job_visits">
                                            {this.state.jobVisitDetails.length > 0 ? (
                                            <Table>
                                                <tbody>
                                                    <tr>
                                                        <td>Job ID</td>
                                                        <td>Visit</td>
                                                        <td>Date</td>
                                                        <td>Start</td>
                                                        <td>End</td>
                                                        <td>Travel</td>
                                                        <td>Work Report</td>
                                                    </tr>
                                                    {this.state.jobVisitDetails.map((job, index) => (
                                                        <tr key={index}>
                                                            <td>{job.JobID}</td>
                                                            <td>{job.SessionID}</td>
                                                            <td>{new Date(job.VisitDate).toLocaleDateString("en-GB")}</td>
                                                            <td>{new Date(job.TimeOn).toLocaleTimeString("en-GB")}</td>
                                                            <td>{new Date(job.TimeOff).toLocaleTimeString("en-GB")}</td>
                                                            <td>{new Date(job.TravelTime).toLocaleTimeString("en-GB")}</td>
                                                            <td style={{ whiteSpace: 'pre-line', backgroundColor: '#f5f5f5', width: '50%' }}>{job.WorkReport}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        ) : (
                                                <p>No visit has been scheduled yet</p>
                                            )}
                                        </TabPane>
                                        {/*END - Tab Content - Job Visits*/}

                                        {/*START - Tab Content - Job Attachments*/}
                                        <TabPane tabId="ht_job_attachments">
                                            {this.state.jobAttachments && this.state.jobAttachments.length > 0 ? (
                                                <>
                                                    {/* Download All and View Toggle Controls */}
                                                    <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        {/* Download All Button */}
                                                        <Button 
                                                            color={this.state.downloadingAll ? "warning" : "success"}
                                                            size="sm"
                                                            onClick={() => this.downloadAllAttachments()}
                                                            disabled={!this.state.jobAttachments || this.state.jobAttachments.length === 0 || this.state.downloadingAll}
                                                            title={this.state.downloadingAll ? "Creating ZIP file..." : "Download all attachments as a ZIP file"}
                                                            style={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center',
                                                                minWidth: '160px'
                                                            }}
                                                        >
                                                            {this.state.downloadingAll ? (
                                                                <>
                                                                    <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                                                                    Please Wait...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa fa-download" style={{ marginRight: '8px' }}></i>
                                                                    Download All ({this.state.jobAttachments ? this.state.jobAttachments.length : 0})
                                                                </>
                                                            )}
                                                        </Button>

                                                        {/* View Toggle Controls */}
                                                        <div>
                                                        <Button 
                                                            color={this.state.attachmentsViewMode === 'list' ? 'primary' : 'secondary'}
                                                            size="sm"
                                                            onClick={() => this.setState({ attachmentsViewMode: 'list' })}
                                                            style={{ marginRight: '10px' }}
                                                        >
                                                            <i className="fa fa-list" style={{ marginRight: '5px' }}></i>
                                                            List View
                                                        </Button>
                                                        <Button 
                                                            color={this.state.attachmentsViewMode === 'thumbnail' ? 'primary' : 'secondary'}
                                                            size="sm"
                                                            onClick={() => {
                                                                this.setState({ attachmentsViewMode: 'thumbnail' });
                                                                // Load thumbnails when switching to thumbnail view
                                                                setTimeout(() => this.loadAllThumbnails(), 100);
                                                            }}
                                                        >
                                                            <i className="fa fa-th-large" style={{ marginRight: '5px' }}></i>
                                                            Thumbnail View
                                                        </Button>
                                                        </div>
                                                    </div>

                                                    {/* List View */}
                                                    {this.state.attachmentsViewMode === 'list' && (
                                                        <Table>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Attachment</td>
                                                                    <td>Date</td>
                                                                    <td>Action</td>
                                                                </tr>
                                                                {(this.state.jobAttachments || []).map((attachment, index) => (
                                                                    <tr key={index}>
                                                                        <td>{attachment.Attachment}</td>
                                                                        <td>{new Date(attachment.AttachedDate).toLocaleDateString("en-GB")}</td>
                                                                        <td>
                                                                            <Button onClick={() => this.downloadAttachment(attachment.JobID, attachment.ItemID, attachment.FileType)} className="btn btn-round" color="primary" size="sm">
                                                                                Download
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    )}

                                                    {/* Thumbnail View */}
                                                    {this.state.attachmentsViewMode === 'thumbnail' && (
                                                        <Row>
                                                            {(this.state.jobAttachments || []).map((attachment, index) => (
                                                                <Col xl="3" lg="4" md="6" sm="12" key={index} style={{ marginBottom: '15px' }}>
                                                                    <div 
                                                                        className="thumbnail-container"
                                                                        data-job-id={attachment.JobID}
                                                                        data-item-id={attachment.ItemID}
                                                                        data-attachment-type={attachment.FileType}
                                                                        style={{
                                                                        position: 'relative',
                                                                        cursor: 'pointer',
                                                                        borderRadius: '8px',
                                                                        overflow: 'hidden',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                        transition: 'all 0.2s ease',
                                                                        backgroundColor: '#fff'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                                                        e.currentTarget.querySelector('.overlay-icons').style.opacity = '1';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                                                                        e.currentTarget.querySelector('.overlay-icons').style.opacity = '0';
                                                                    }}
                                                                    >
                                                                        {/* Thumbnail Image/Placeholder */}
                                                                        <div style={{
                                                                            width: '100%',
                                                                            minHeight: '150px',
                                                                            maxHeight: '250px',
                                                                            backgroundColor: '#f8f9fa',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            position: 'relative',
                                                                            overflow: 'hidden'
                                                                        }}>
                                                                            {this.renderThumbnail(attachment)}
                                                                            
                                                                            {/* Hover Overlay with Icons */}
                                                                            <div 
                                                                                className="overlay-icons"
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '0',
                                                                                    left: '0',
                                                                                    right: '0',
                                                                                    bottom: '0',
                                                                                    background: 'rgba(0, 0, 0, 0.6)',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    opacity: '0',
                                                                                    transition: 'opacity 0.2s ease',
                                                                                    gap: '15px'
                                                                                }}
                                                                            >
                                                                                
                                                                                {/* Preview Button */}
                                                                                <div
                                                                                    style={{
                                                                                        width: '45px',
                                                                                        height: '45px',
                                                                                        borderRadius: '50%',
                                                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        cursor: 'pointer',
                                                                                        transition: 'all 0.2s ease'
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.openPreviewModal(attachment);
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = '#28a745';
                                                                                        e.currentTarget.style.color = 'white';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                                                                                        e.currentTarget.style.color = 'inherit';
                                                                                    }}
                                                                                    title="Preview"
                                                                                >
                                                                                    <i className="fa fa-eye" style={{ fontSize: '18px' }}></i>
                                                                                </div>

                                                                                {/* Download Button */}
                                                                                <div
                                                                                    style={{
                                                                                        width: '45px',
                                                                                        height: '45px',
                                                                                        borderRadius: '50%',
                                                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        cursor: 'pointer',
                                                                                        transition: 'all 0.2s ease'
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.downloadAttachment(attachment.JobID, attachment.ItemID, attachment.FileType);
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = '#007bff';
                                                                                        e.currentTarget.style.color = 'white';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                                                                                        e.currentTarget.style.color = 'inherit';
                                                                                    }}
                                                                                    title="Download"
                                                                                >
                                                                                    <i className="fa fa-download" style={{ fontSize: '18px' }}></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        {/* File Info Bar */}
                                                                        <div style={{
                                                                            padding: '12px 15px',
                                                                            backgroundColor: '#fff',
                                                                            borderTop: '1px solid #eee'
                                                                        }}>
                                                                            <div style={{
                                                                                fontSize: '13px',
                                                                                fontWeight: '600',
                                                                                color: '#333',
                                                                                marginBottom: '4px',
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis'
                                                                            }} title={attachment.Attachment}>
                                                                                {attachment.Attachment}
                                                                            </div>
                                                                            <div style={{
                                                                                fontSize: '11px',
                                                                                color: '#666'
                                                                            }}>
                                                                                {new Date(attachment.AttachedDate).toLocaleDateString("en-GB")}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    )}
                                                </>
                                            ) : (
                                                <p>No results</p>
                                            )}
                                        </TabPane>
                                        {/*END - Tab Content - Job Attachments*/}

                                        {/*START - Tab Content - Quote Details*/}
                                        <TabPane tabId="ht_quote_details">
                                            <Table>
                                                {this.state.quoteDetails.map((quote, index) => (
                                                    <tbody key={index}>
                                                        <tr>
                                                            <td style={{ width: '300px' }}>Quote Ref</td>
                                                            <td>{quote.quote_ref}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Submitted To Customer</td>
                                                            <td>{new Date(quote.submitted_to_customer).toLocaleDateString("en-GB")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Site</td>
                                                            <td>{quote.site_name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Work Type</td>
                                                            <td>{quote.work_type}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Quote Status</td>
                                                            <td>{quote.quote_status}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Priority</td>
                                                            <td>{quote.priority}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Price</td>
                                                            <td>£{quote.total_value}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fault Location</td>
                                                            <td>{quote.fault_location}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ verticalAlign: 'top' }}>Fault Description</td>
                                                            <td style={{ whiteSpace: 'pre-line', backgroundColor: '#f5f5f5' }}>{quote.description}</td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </Table>
                                        </TabPane>
                                        {/*END - Tab Content - Quote Details*/}

                                    </TabContent>
                                    {/*END - Tab Content*/}


                                </CardBody>
                                <CardFooter>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>

                    {/*END - Tab Content*/}

                    {/* File Preview Modal */}
                    <Modal isOpen={this.state.previewModal} toggle={this.togglePreviewModal} size="lg">
                        <ModalHeader toggle={this.togglePreviewModal}>
                            {this.state.previewFile ? `Preview: ${this.state.previewFile.Attachment}` : 'File Preview'}
                        </ModalHeader>
                        <ModalBody>
                            {this.state.previewFile && this.renderFilePreview(
                                this.state.previewFile.FileBlob, 
                                this.state.previewFile.Attachment,
                                this.state.previewFile.FileType
                            )}
                        </ModalBody>
                    </Modal>

                    {/* Large Preview Modal from Thumbnails */}
                    <Modal isOpen={this.state.largePreviewModal} toggle={this.closePreviewModal} size="xl">
                        {/* Custom modal header with two columns */}
                        <div style={{ 
                            backgroundColor: '#f8f9fa', 
                            borderBottom: '1px solid #dee2e6',
                            padding: '15px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            {/* Filename */}
                            <div style={{ 
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                marginRight: '20px'
                            }}>
                                <span style={{ fontWeight: '400', color: '#495057', fontSize: '16px' }}>
                                    {this.state.largePreviewAttachment ? this.state.largePreviewAttachment.Attachment : 'File'}
                                </span>
                            </div>
                            
                            {/* Close button */}
                            <div>
                                <button
                                    type="button"
                                    onClick={this.closePreviewModal}
                                    style={{
                                        background: '#dc3545',
                                        border: '1px solid #dc3545',
                                        borderRadius: '8px',
                                        width: '36px',
                                        height: '36px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px',
                                        fontWeight: '700',
                                        color: 'white',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        margin: '0',
                                        padding: '0',
                                        boxShadow: '0 2px 4px rgba(220,53,69,0.2)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = '#c82333';
                                        e.target.style.borderColor = '#bd2130';
                                        e.target.style.transform = 'scale(1.08)';
                                        e.target.style.boxShadow = '0 4px 8px rgba(220,53,69,0.3)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = '#dc3545';
                                        e.target.style.borderColor = '#dc3545';
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.boxShadow = '0 2px 4px rgba(220,53,69,0.2)';
                                    }}
                                    onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                                    onMouseUp={(e) => e.target.style.transform = 'scale(1.08)'}
                                >
                                    ×
                                </button>
                            </div>
                        </div>
                        <ModalBody style={{ padding: '20px', maxHeight: '80vh', overflow: 'auto' }}>
                            {this.state.largePreviewContent && this.renderLargePreview()}
                        </ModalBody>
                    </Modal>

                </div>
            </>
        );
    }
}

export default SiteSearch;